import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import MainMenu, { MainMenuOption } from './MainMenu.tsx'
import { Column, Row } from '../common/pure/FlexContainer.tsx'
import { BoltCheckLogo } from '../common/inline-svg.tsx'
import { GenericStorage } from '../../tools/dom/storage.ts'
import ResizableWidth from '../common/pure/ResizableWidth.tsx'
import env from '../../tools/env.ts'
import SubMenu from './SubMenu.tsx'
import { getPropertyValuePx } from '../../tools/dom/css-properties.ts'

const mainMenuStorage = new GenericStorage<MainMenuOption>('MAIN_MENU_STORAGE')
export default function SideBar() {
    const { pathname } = useLocation()
    const [selectedOption, setSelectedOption] = useState<MainMenuOption>(
        mainMenuStorage.read() ?? 'organization'
    )

    const changeMainMenuOption = (option: MainMenuOption) => {
        setSelectedOption(option)
        mainMenuStorage.store(option)
    }

    useEffect(() => {
        if (pathname.startsWith('/service-window')) changeMainMenuOption('organization')
    }, [pathname])

    return (
        <Column className="side-bar">
            <Link to="/">
                <Row className="side-bar__header" gap={1} arrangement="start" alignment="center">
                    <BoltCheckLogo />
                    <div className="bolt-check-logo-text">Bolt-Check</div>
                </Row>
            </Link>

            <Row grow>
                <Column className="side-bar__main-menu">
                    {/* NOTE: Let's assume there will never be enough main menu options to require scroll. */}
                    <MainMenu
                        selectedOption={selectedOption}
                        onOptionSelected={(option) => changeMainMenuOption(option)}
                    />
                    <span className="version-tag">{env('VERSION_TAG')}</span>
                </Column>

                <ResizableWidth
                    // storageKey="SUB_MENU_WIDTH" - NOTE: Currently not storing menu width using `storageKey` prop.
                    defaultWidth={getPropertyValuePx('--sub-menu-width')}
                    maxWidth={getPropertyValuePx('--sub-menu-max-width')}
                >
                    <Column gap={1} grow className="side-bar__sub-menu">
                        <Column container>
                            <Column grow scroll>
                                <SubMenu selectedOption={selectedOption} />
                            </Column>
                        </Column>
                    </Column>
                </ResizableWidth>
            </Row>
        </Column>
    )
}
